import * as React from 'react';
import { makeStyles } from 'tss-react/mui';
import { MAIN_THEME } from '@styles';

type AuthLayoutProps = {
  children?: React.ReactNode;
  mainContainer?: string | React.CSSProperties;
};

const useStyles = makeStyles<{
  mainContainer?: string | React.CSSProperties;
}>()((theme, { mainContainer }) => ({
  mainContainer: {
    width: '100%',
    height: '100vh',
    padding: mainContainer ? '0' : '20px 0',
    background: mainContainer
      ? 'none'
      : `linear-gradient(0deg, ${MAIN_THEME.color.white}, ${MAIN_THEME.color.white86})`,
    ...(mainContainer && typeof mainContainer === 'object'
      ? mainContainer
      : {}),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    boxSizing: 'border-box',
  },
}));

const AuthLayout: React.FC<AuthLayoutProps> = ({ children, mainContainer }) => {
  const { classes: styles } = useStyles({ mainContainer });

  return <div className={styles.mainContainer}>{children}</div>;
};

export default AuthLayout;
